import { ISocialMediaTypeDTO } from "../ISocialMediaTypeDTO";
import { ICustomerPublicDTO } from "../user-dto";

export enum CustomerSocialMediaStatusEnum {
  ACTIVE = "a",
  INACTIVE = "i",
  DELETED = "x",
}

export type CustomerSocialMediaStatusTypes = `${CustomerSocialMediaStatusEnum}`;

export interface ICustomerSocialMediaDTO {
  id: number;
  customer: number;
  customerData: ICustomerPublicDTO;
  type: number;
  typeData: ISocialMediaTypeDTO;
  url: string;
  status: CustomerSocialMediaStatusTypes;
  createdAt: string;
  updatedAt: string;
}

export interface ICustomerSocialMediaStatusDTO {
  status: CustomerSocialMediaStatusTypes;
  name: string;
  description: string;
  color: string;
}